import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
export const withPresetIconProps = (Component)=>(props)=>{
        return /*#__PURE__*/ React.createElement(Component, _object_spread_props(_object_spread({}, props), {
            size: IconSize.MEDIUM,
            disableDefaultColors: true
        }));
    };
